import * as v from "valibot";

const NUMBER = /^-?\d+(\.\d+)?$/;
const INTEGER = /^\d+$/;

export const coerceNumber = () =>
  v.pipe(
    v.string(),
    v.check((val: string) => NUMBER.test(val), "Invalid number"),
    v.transform((val: string) => Number(val)),
    v.number(),
  );

export const coerceBoolean = () =>
  v.pipe(
    v.string(),
    v.check((val: string) => val === "true" || val === "1" || val === "false" || val === "0", "Invalid boolean"),
    v.transform((val: string) => val === "true" || val === "1"),
    v.boolean(),
  );

export const coerceInteger = () =>
  v.pipe(
    v.string(),
    v.check((val: string) => INTEGER.test(val), "Invalid integer"),
    v.transform((val: string) => Number(val)),
    v.integer(),
  );

export const coerceStringArray = () =>
  v.pipe(
    v.string(),
    v.transform((val: string) => val.split(",")),
    v.array(v.string()),
  );

export const coerceNumberArray = () =>
  v.pipe(
    v.string(),
    v.check((val: string) => val.split(",").every((part: string) => NUMBER.test(part)), "Invalid number list"),
    v.transform((val: string) => val.split(",").map((part: string) => Number(part))),
    v.array(v.number()),
  );
